$(window).on('load', function() {
  var geoCurrencyT = Geolizr.geoData.currencyCode;
  var geoCountryName = Geolizr.geoData.countryName;
  var geoTimeZone = Geolizr.geoData.timezone;
  console.log("geoCurrencyT: "+geoCurrencyT);
  console.log("geoCountryName: "+geoCountryName);
  console.log("geoTimeZone: "+geoTimeZone);
  var currentCurrency = getCookie('cart_currency');
  var currentUrl = new URL(window.location.href);


  function geoGiftCard() {
    if (geoCountryName === undefined) return;
    document.body.setAttribute('data-country-name', geoCountryName);

    const giftCardItems = document.querySelectorAll('.gift-card-item');
    const productGiftCard = document.querySelector('[data-product-gift-card]');
    const searchResults = document.querySelector('.search-results');
    

    if (giftCardItems && geoCountryName != 'Australia') {
      giftCardItems.forEach(giftCardItem => {
        giftCardItem.parentElement.setAttribute('hidden', '');
      });
    }

    if (productGiftCard && geoCountryName != 'Australia') {
      window.location.replace("/");
    }

    if (!searchResults) return;
    const forGiftCard = document.querySelector('.for-gift-card');
    const hasGiftCard = searchResults.dataset.giftCard;
    const pageHeader = searchResults.querySelector('.PageHeader');
    if (hasGiftCard && geoCountryName != 'Australia') {
      forGiftCard.removeAttribute('hidden');
      pageHeader.setAttribute('hidden', '');
    }
  }

  
  geoGiftCard();
  

  function getGeo() {
    var zonecheck = geoTimeZone.includes("Europe");
    if(geoCurrencyT){

      setCookie('geoISO', geoCurrencyT, 1);

      if(currentCurrency != geoCurrencyT){
        if(geoCurrencyT == 'AUD'){
          setCookie('cart_currency', 'AUD', 1);
          document.location  = currentUrl.href;
        }
        else if(geoCurrencyT == 'CAD'){
          setCookie('cart_currency', 'CAD', 1);
          document.location  = currentUrl.href;
        }
        else if(geoCurrencyT == 'GBP'){
          setCookie('cart_currency', 'GBP', 1);
          document.location  = currentUrl.href;
        }
        else if(geoCurrencyT == 'NZD'){
          setCookie('cart_currency', 'NZD', 1);
          document.location  = currentUrl.href;
        }
        else if(geoCurrencyT == 'EUR'){
          setCookie('cart_currency', 'EUR', 1);
          document.location  = currentUrl.href;
        }
        else{
          if(zonecheck){
            setCookie('cart_currency', 'EUR', 1);
            document.location  = currentUrl.href;
          }else{
            setCookie('cart_currency', 'USD', 1);
            document.location  = currentUrl.href;
          }
        }
      }
    }
  }
  var fLoad = getCookie('first_view');
  if(!fLoad) {
      // first time loaded!
      getGeo();
      setCookie('first_view', "1", 1);
  }
});

function setCookie(cname,cvalue,days) {
    var d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}
